export const containsOnlyNumbersOrEnglishLetters = (str): boolean => {
  return /^[A-Za-z0-9]*$/.test(str);
};



// WEBPACK FOOTER //
// ./src/app/_helpers/contains-only-numbers-or-english-letters.ts